// extracted by mini-css-extract-plugin
export default {"fill":"CreditScoreProgressCircle_fill__l3tHo","outline":"CreditScoreProgressCircle_outline__y7nLQ"};